import Command from "@ckeditor/ckeditor5-core/src/command";
import randomUUIDGenerator from '../../src/utils/randomUUIDGenerator.js';

export default class GenerateCustomGuidCommand extends Command {
    execute() {
        this.editor.fire('newcustomguid', { id: randomUUIDGenerator() })
    }
}